export enum Steps {
    SEARCH = 'search',
    PREVIEW = 'preview',
    REPORT = 'report',
    CREATE_COLLECTION = 'create_collection',
}

export interface BasePost {
    id: string;
    [key: string]: unknown;
}

export interface ReportData {
    targetId: string;
    targetType: string;
}

export interface CreateCollectionData {
    postIds: string[];
}

export interface DialogState {
    step?: string;
    [key: string]: unknown;
}

export interface HistoryState {
    usr?: {
        dialogName?: string;
        [key: string]: unknown;
    };
    [key: string]: unknown;
}

export interface UseDialogStepsHook {
    goToStep: (step: Steps, additionalData?: Record<string, unknown>) => void;
    replaceStep: (step: Steps, additionalData?: Record<string, unknown>) => void;
    navigateBack: () => void;
}

export interface UseCreateCollectionNavigationProps {
    setSelectedPosts: (value: string[] | ((prev: string[]) => string[])) => void;
}
